import { useMemo, useCallback } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import PortalIdParser from 'PortalIdParser';
import { useObjectTypeSupportsCustomization } from './internal/useObjectTypeSupportsCustomization';
import { isIdle, isLoading, isRejected } from '../common/types/FetchStatus';
import SkeletonLink from '../common/components/internal/SkeletonLink';
import { SettingsIcon } from 'foundations-assets';
import { Flex } from 'foundations-components/components/Flex';
import { Small } from 'foundations-components/transitional/components/Small';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const RecordCustomizationSettingsLink = ({
  objectTypeId,
  children,
  onTrackClick
}) => {
  const objectTypeSupportsCustomizationState = useObjectTypeSupportsCustomization(objectTypeId, 'CRM_RECORD_PAGE');

  // This param is used when building links to the settings page to provide a backlink to records
  const eschref = `${window.location.pathname}${window.location.search}`;
  const recordCustomizationSettingsLink = useMemo(() => {
    const baseSettingsUrl = `/sales-products-settings/${PortalIdParser.get()}/object/${objectTypeId}/record-customization`;
    return `${baseSettingsUrl}?eschref=${encodeURIComponent(eschref)}`;
  }, [eschref, objectTypeId]);
  const handleTrackClick = useCallback(() => {
    onTrackClick === null || onTrackClick === void 0 || onTrackClick({
      fromObjectTypeId: objectTypeId,
      path: recordCustomizationSettingsLink
    });
  }, [onTrackClick, recordCustomizationSettingsLink, objectTypeId]);
  if (isLoading(objectTypeSupportsCustomizationState) || isIdle(objectTypeSupportsCustomizationState)) {
    return /*#__PURE__*/_jsx(SkeletonLink, {
      width: 80,
      "data-test-id": "record-customization-skeleton-link"
    });
  }
  if (isRejected(objectTypeSupportsCustomizationState) || !objectTypeSupportsCustomizationState.data) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "record-customization-settings-button",
    href: recordCustomizationSettingsLink,
    onClick: handleTrackClick,
    responsive: false,
    size: "sm",
    use: "transparent",
    children: /*#__PURE__*/_jsxs(Flex, {
      as: "span",
      alignItems: "center",
      gap: "100",
      children: [/*#__PURE__*/_jsx(SettingsIcon, {}), /*#__PURE__*/_jsx(Small, {
        weight: "demi",
        children: children
      })]
    })
  });
};
export default RecordCustomizationSettingsLink;